function activateChosen(el) {
  $(el).chosen();
}

export default activateChosen;
